import React from "react"
import { Pressable, StyleSheet, View } from "react-native"
import { FontAwesome5 } from "@expo/vector-icons"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

const Option = ({ selected, onPress, icon, label, testID }) => (
    <Pressable
        testID={testID}
        onPress={onPress}
        style={[styles.option, selected && styles.optionSelected]}
    >
        <FontAwesome5
            name={selected ? "dot-circle" : "circle"}
            size={16}
            color={selected ? theme.colors.primary : theme.colors.grey}
        />
        <FontAwesome5 name={icon} size={16} color={theme.colors.black} />
        <TextM fontSize={15} fontWeight="Medium" wrap style={{ flex: 1 }}>
            {label}
        </TextM>
    </Pressable>
)

/**
 * La famille a déjà une carte chez nous : elle la réutilise telle quelle, ou en
 * donne une autre — qui devient alors la carte des prélèvements.
 */
export const SavedCardChoiceCard = ({ savedCard, useSavedCard, onChange }) => (
    <View style={styles.card}>
        <TextM fontWeight="bold" fontSize={18} color={theme.colors.black}>
            Moyen de paiement
        </TextM>
        <Option
            testID="saved-card-option"
            selected={useSavedCard}
            onPress={() => onChange(true)}
            icon="credit-card"
            label={`Utiliser ma carte •••• ${savedCard.last4}`}
        />
        <Option
            testID="new-card-option"
            selected={!useSavedCard}
            onPress={() => onChange(false)}
            icon="plus"
            label="Ajouter un autre moyen de paiement"
        />
    </View>
)

const styles = StyleSheet.create({
    card: {
        padding: 20,
        borderRadius: 20,
        gap: 12,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
    },
    option: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
        padding: 14,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
    },
    optionSelected: {
        borderColor: theme.colors.primary,
    },
})
